import axios from './api';

import type { InstantSurveyType } from './types';
import { transformInstantSurveyType, transformInstantSurveyTypes } from './utilities/helpers';

interface ReadInstantSurveyTypeOptions {
  id: string;
  signal?: AbortSignal;
}

interface ReadInstantSurveyTypesOptions {
  signal?: AbortSignal;
}

interface SurveyTypeListResponse {
  results: InstantSurveyType[];
}

export const readInstantSurveyTypes = async ({ signal }: ReadInstantSurveyTypesOptions = {}) => {
  return axios({
    method: 'get',
    signal,
    url: '/instantsurvey/instantsurveytype',
  }).then(({ data }): SurveyTypeListResponse => transformInstantSurveyTypes(data));
};

export const readInstantSurveyType = async ({ id, signal }: ReadInstantSurveyTypeOptions) => {
  return axios({
    method: 'get',
    signal,
    url: `/instantsurvey/instantsurveytype/${id}`,
  }).then(({ data }): InstantSurveyType => transformInstantSurveyType(data));
};
